import script from "./HrFilePreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./HrFilePreview.vue?vue&type=script&lang=ts&setup=true"

import "./HrFilePreview.vue?vue&type=style&index=0&id=2e06f698&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e06f698"]])

export default __exports__